<template>
  <div class="news_details_wrap news-detail-page">
    <PCNavbar selectIndex="4-2"/>
    <MobileNavBar :currentActive="3"/>
    <div class="news_content">
      <el-breadcrumb class="news_bread" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>新闻详情</el-breadcrumb-item>
      </el-breadcrumb>

      <article class="news_article">
        <header class="news_article_header">
          <h1 class="news_title">
            济南临港产业发展集团领导莅临我司参观交流
          </h1>
          <div class="news_meta">
            <span class="news_meta_item">来源：山东智能工业装备公司</span>
            <span class="news_meta_sep">·</span>
            <span class="news_meta_item">投稿时间：2026-07-08</span>
          </div>
        </header>

        <div class="article_body">
          <p class="lead">
            2026年7月8日下午，济南临港产业发展集团有限公司领导一行莅临山东智能工业装备有限公司参观指导。我司相关负责人热情接待，双方围绕新能源充电桩产品、核心技术能力及产业园区配套能源建设等议题展开深入交流，来访领导对我司产品与研发实力表示认可，并表达了合作意愿。
          </p>

          <figure class="figure_block">
            <img
              class="article_img"
              :src="images.img1"
              alt="济南临港产业发展集团领导来访参观"
            >
            <figcaption class="figure_caption">济南临港产业发展集团领导一行莅临我司</figcaption>
          </figure>

          <h2 class="section_title">一、技术对标，实力获认可</h2>

          <p class="body_paragraph">
            交流过程中，我司技术人员系统介绍了公司在充电领域的整体解决方案。其中，720KW四轮充电桩凭借稳定的输出性能、完善的智能通信接口及远程监控能力，可灵活适配商业停车场、公共充电站等多种应用场景，受到来访领导重点关注，双方就产品参数与工程落地细节进行了深入探讨。
          </p>

          <figure class="figure_block">
            <img
              class="article_img"
              :src="images.img2"
              alt="720KW四轮充电桩产品展示"
            >
            <figcaption class="figure_caption">720KW四轮充电桩产品展示</figcaption>
          </figure>

          <p class="body_paragraph">
            围绕二轮充电桩设备的核心控制与安全保障，技术人员现场讲解了控制模块的内部结构、核心电路设计及智能化管理逻辑，展示了产品从硬件选型到工艺制造的全流程能力。来访领导对公司在研发创新与品质管控方面的专业水平给予高度评价。
          </p>

          <figure class="figure_block">
            <img
              class="article_img"
              :src="images.img3"
              alt="二轮充电桩设备核心技术讲解"
            >
            <figcaption class="figure_caption">二轮充电桩设备核心技术讲解</figcaption>
          </figure>

          <p class="body_paragraph">
            在与北京理工大学联合研发的基础上，公司已形成涵盖高功率直流电源、双向DC-DC电源等在内的系列产品布局，相关资质证书与荣誉成果同步呈现。来访领导认为，我司在新能源电源领域具备扎实的技术积累与可持续的创新能力，为后续合作提供了有力支撑。
          </p>

          <figure class="figure_block">
            <img
              class="article_img"
              :src="images.img4"
              alt="联合研发成果与核心产品"
            >
            <figcaption class="figure_caption">联合研发成果与核心产品</figcaption>
          </figure>

          <h2 class="section_title">二、对接需求，共商合作路径</h2>

          <p class="body_paragraph">
            在技术交流基础上，双方举行了座谈研讨会。我司介绍了设备供应、技术合作、项目共建等多元化合作模式；济南临港产业发展集团领导则分享了集团在产业园区运营管理、新能源设施建设及综合能源服务等方面的布局与需求。双方优势高度互补，在多个潜在合作方向上达成初步共识，合作意愿明确而务实。
          </p>

          <figure class="figure_block figure_block--end">
            <img
              class="article_img"
              :src="images.img5"
              alt="双方座谈交流"
            >
            <figcaption class="figure_caption">双方座谈交流</figcaption>
          </figure>

          <p class="body_paragraph">
            此次来访交流，进一步拓宽了我司在产业园区新能源配套领域的合作渠道。下一步，双方将持续保持密切沟通，加快推动具体项目对接与落地，共同为新能源产业高质量发展注入新动能。
          </p>
        </div>
      </article>
    </div>

    <div class="news_detail_page_foot">
      <CallMe/>
      <MobileCallme/>
    </div>
  </div>
</template>

<script>
import PCNavbar from '@/components/report_list/SpaNav.vue'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/MobileCallme.vue'

export default {
  components: {
    PCNavbar,
    MobileNavBar,
    CallMe,
    MobileCallme,
  },
  data () {
    return {
      images: {
        img1: require('@/assets/images/news-list/news5/image5.jpg'),
        img2: require('@/assets/images/news-list/news5/image2.jpg'),
        img3: require('@/assets/images/news-list/news5/image3.jpg'),
        img4: require('@/assets/images/news-list/news5/image1.jpg'),
        img5: require('@/assets/images/news-list/news5/image4.jpg'),
      },
    }
  },
}
</script>

<style lang="scss">
@import '~@/assets/styles/news-detail-responsive.scss';
</style>
